import { useState } from "react"
import { Link, useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import { CredentialsStep } from "./CredentialsStep"
import { VerificationStep } from "./VerificationStep"
import { AuthTopbar } from "../../modules/AuthTopbar"
import styles from "./index.module.css"
import { Card } from "@cividao/components"

const LoginStep = {
  CREDENTIALS: "CREDENTIALS",
  VERIFICATION: "VERIFICATION",
} as const

type LoginStep = (typeof LoginStep)[keyof typeof LoginStep]

export function LoginTemplate() {
  const { t } = useTranslation("auth")
  const navigate = useNavigate()
  const [currentStep, setCurrentStep] = useState<LoginStep>(LoginStep.CREDENTIALS)
  const [email, setEmail] = useState("")

  const handleCredentialsComplete = (userEmail: string) => {
    setEmail(userEmail)
    setCurrentStep(LoginStep.VERIFICATION)
  }

  const handleBack = () => {
    setCurrentStep(LoginStep.CREDENTIALS)
  }

  const isCredentials = currentStep === LoginStep.CREDENTIALS
  const topbarText = isCredentials ? t("shared.step.credentials") : t("shared.step.verification")
  const stepNumber = isCredentials ? 1 : 2

  return (
    <main className={styles.container}>
      <AuthTopbar
        text={topbarText}
        currentStep={stepNumber}
        totalSteps={2}
        onBack={isCredentials ? () => navigate("/") : undefined}
      />

      <div className={styles.content}>
        <Card>
          {currentStep === LoginStep.CREDENTIALS ? (
            <>
              <h1>{t("login.title")}</h1>
              {sessionStorage.getItem("returnTo")?.startsWith("/vote/") && <p>{t("login.votePrompt")}</p>}
              <CredentialsStep onComplete={handleCredentialsComplete} />
              <Link to="/register">{t("login.registerLink")}</Link>
            </>
          ) : (
            <VerificationStep email={email} onBack={handleBack} />
          )}
        </Card>
      </div>
    </main>
  )
}
